<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M19.6667 13H4.33334C3.78134 13 3.33334 12.552 3.33334 12C3.33334 11.448 3.78134 11 4.33334 11H19.6667C20.2187 11 20.6667 11.448 20.6667 12C20.6667 12.552 20.2187 13 19.6667 13Z"/>
</svg>
